import React, {useMemo} from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";

const HomePinSection = ({ pinItem, boardTypeName, onDestroyPin, location = '', created = false }) => {
    const { user_id = '' } = useSelector(({ authenticationReducer }) => {
        return {
            user_id: authenticationReducer.user_id,
        };
    });

    const { is_owner = false, is_manager = false } = useSelector(({ stationReducer }) => {
        const { stationInfo } = stationReducer || {};
        return {
            is_owner: stationInfo?.data?.is_owner,
            is_manager: stationInfo?.data?.is_manager,
        };
    });

    const tipOne = useMemo(() => {
        let tipText = `스트리머가 고정한 ${boardTypeName}입니다.`;

        // 채널 주인 일때
        if(is_owner) { 
            tipText = pinItem?.worker_id === user_id ? '고정해제' :  `${pinItem?.worker_nick}이/가 고정한 ${boardTypeName}입니다.`;
        }  else { // 채널 주인은 아닐때

            //매니저 본인 일때랑 다른 매니저 일때
            if(is_manager) {
                tipText = pinItem?.worker_id === user_id ? '고정해제' : `${pinItem?.worker_nick}이/가 고정한 ${boardTypeName}입니다.`;
                tipText =  pinItem?.worker_id === global.bj_id ? `스트리머가 고정한 ${boardTypeName}입니다.` : tipText;
            } else {
                // 일반 유저 일때 스트리머인지, 매니저인지만 노출
                tipText =  pinItem?.worker_id === global.bj_id ? `스트리머가 고정한 ${boardTypeName}입니다.` : `${pinItem?.worker_nick}이/가 고정한 ${boardTypeName}입니다.`;
            }
        }

        return tipText;
    }, [user_id, is_owner, is_manager, pinItem, boardTypeName]);

    const tipTwo = useMemo(() => {
        let tipText = '';
        // 주인일 때
        if(is_owner) { 
            // worker_id가 다르면 매니저가 한 케이스
            tipText = pinItem?.worker_id !== user_id ? "(클릭하여 고정 해제)" : null;
        } else {
            // 매니저 본인일 경우
            if(is_manager) {
                tipText = pinItem?.worker_id === user_id ? null : '(클릭하여 고정 해제)';
            }
        }

        return tipText;
    }, [user_id, is_owner, is_manager, pinItem]);

    return (
        <button
            type="button"
            className={'pin'}
            tip={isMobile ? null : tipOne}
            tip2={isMobile ? null : tipTwo}
            onClick={(event) => {
                event.preventDefault();
                if (is_owner || is_manager) {
                    onDestroyPin && onDestroyPin(pinItem, location, created)
                }
            }}
        >
            {!isMobile && <span>고정해제</span>}
        </button>
    );
};

export default HomePinSection;